<template>
  <div class="app" v-bind:class="className">
    <Board />
    <Header />
    <GameOver v-if="gameOver"/>
  </div>
</template>

<script>
import Board from "./components/Board.vue";
import Header from "./components/Header.vue";
import GameOver from "./components/GameOver.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "app",
  methods: {
    ...mapActions(["makeInitialMap", "increaseElapsedTime"])
  },
  computed: {
    ...mapGetters(["level", "gameOver"]),
    className() {
      const levelColor = this.level % 5;
      return {
        "color-0": levelColor === 0,
        "color-1": levelColor === 1,
        "color-2": levelColor === 2,
        "color-3": levelColor === 3,
        "color-4": levelColor === 4,
        animate: this.level !== 0
      };
    }
  },
  mounted: function() {
    this.makeInitialMap();
    // TODO: use requestAnimationFrame
    setInterval(this.increaseElapsedTime, 1000);
  },
  components: {
    Board,
    Header,
    GameOver
  }
};
</script>

<style>
body {
  background: #333;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}
.color-0 {
  --color: #00afff;
}
.color-1 {
  --color: #ff4b3e;
}
.color-2 {
  --color: #7ac74f;
}
.color-3 {
  --color: #f56416;
}
.color-4 {
  --color: #fde74c;
}
.color-0.animate {
  animation: 0.5s level-transition-0;
}
.color-1.animate {
  animation: 0.5s level-transition-1;
}
.color-2.animate {
  animation: 0.5s level-transition-2;
}
.color-3.animate {
  animation: 0.5s level-transition-3;
}
.color-4.animate {
  animation: 0.5s level-transition-4;
}

.app {
  width: 300px;
  margin: 0 auto;
}

@keyframes level-transition-0 {
  50% {
    opacity: 0;
    transform: scale(2);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes level-transition-1 {
  50% {
    opacity: 0;
    transform: scale(2);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes level-transition-2 {
  50% {
    opacity: 0;
    transform: scale(2);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes level-transition-3 {
  50% {
    opacity: 0;
    transform: scale(2);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes level-transition-4 {
  50% {
    opacity: 0;
    transform: scale(2);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
